module.exports = __webpack_public_path__ + "static/media/1001279DO.2c8b4ca7.jpg";